module.exports = __webpack_public_path__ + "img/filter.b91be478.svg";